@import (reference) '../../../../constants/spacing.module.less';

.navigation-button {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  gap: @space-8;
  padding: @space-8;
  border-radius: 4px;
  color: var(--default--text-color--17);
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;

  &:hover {
    background-color: var(--order-details-canvas--header-buttons--focus--background-color);
    color: var(--order-details-canvas--header-buttons--focus--text-color);
  }

  &:active {
    background-color: var(--order-details-canvas--header-buttons--active--background-color);
    color: var(--order-details-canvas--header-buttons--active--text-color);
  }

  &:focus-visible {
    background-color: var(--order-details-canvas--header-buttons--focus--background-color);
    outline: 1px solid var(--tabs--tab-button--hover--text-color);
    outline-offset: -1px;
    color: var(--order-details-canvas--header-buttons--focus--text-color);
  }

  &.selected {
    background-color: var(--order-details-canvas--header-buttons--selected--background-color);
    color: var(--order-details-canvas--header-buttons--selected--text-color);
    font-weight: 500;
  }
}
